import React from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import {
  ClockIcon,

  DocumentArrowUpIcon,
  DocumentArrowDownIcon,
  FolderIcon } from
'@heroicons/react/24/outline';
import useRouter from '@/hooks/useRouter';
import DropdownFilter from '@/components/DropdownFilter';

export default function SortBy(_props) {
  const { location, history } = useRouter();

  const search = queryString.parse(location.search) || {};

  function onChange(order) {
    const search = queryString.parse(location.search) || {};

    search.order = order;
    delete search.page;

    history.push({
      pathname: location.pathname,
      search: queryString.stringify(_.extend({}, search))
    });
  }

  const orderMap = {
    Newest: {
      name: 'Newest',
      param: 'createdAt desc'
    },
    NameAscending: {
      name: 'Name (a-first)',
      param: 'name asc'
    },
    NameDescending: {
      name: 'Name (z-first)',
      param: 'name desc'
    },
    ProjectsCompleted: {
      name: 'Projects completed',
      param: 'numberOfProjectsCompleted desc'
    },
    ProjectsActive: {
      name: 'Projects incomplete/active',
      param: 'numberOfProjectsActive desc'
    },
    ProjectsCancelled: {
      name: 'Projects cancelled',
      param: 'numberOfProjectsCancelled desc'
    },
    EventsCompleted: {
      name: 'Events completed',
      param: 'numberOfEventsCompleted desc'
    },
    EventsActive: {
      name: 'Events incomplete/active',
      param: 'numberOfEventsActive desc'
    },
    EventsCancelled: {
      name: 'Events cancelled',
      param: 'numberOfEventsCancelled desc'
    }
  };

  const reverseOrderMap = _.mapKeys(orderMap, function (value, _key) {
    return value.param;
  });

  return (
    <DropdownFilter subtitle="Sort by:" title={reverseOrderMap[search.order]?.name || 'Newest'}>
      <DropdownFilter.MenuItem
        icon={ClockIcon}
        title={orderMap.Newest.name}
        subtitle="Display recently created sites first."
        selected={!search.order || search.order === orderMap.Newest.param}
        onClick={() => onChange(orderMap.Newest.param)} />
      
      <DropdownFilter.MenuItem
        icon={DocumentArrowUpIcon}
        title={orderMap.NameAscending.name}
        subtitle="Display sites by name, starting with A."
        selected={search.order === orderMap.NameAscending.param}
        onClick={() => onChange(orderMap.NameAscending.param)} />
      
      <DropdownFilter.MenuItem
        icon={DocumentArrowDownIcon}
        title={orderMap.NameDescending.name}
        subtitle="Display sites by name, starting with Z."
        selected={search.order === orderMap.NameDescending.param}
        onClick={() => onChange(orderMap.NameDescending.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.ProjectsCompleted.name}
        subtitle="Display sites by number of completed projects."
        selected={search.order === orderMap.ProjectsCompleted.param}
        onClick={() => onChange(orderMap.ProjectsCompleted.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.ProjectsActive.name}
        subtitle="Display sites by number of incomplete/active projects."
        selected={search.order === orderMap.ProjectsActive.param}
        onClick={() => onChange(orderMap.ProjectsActive.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.ProjectsCancelled.name}
        subtitle="Display sites by number of cancelled projects."
        selected={search.order === orderMap.ProjectsCancelled.param}
        onClick={() => onChange(orderMap.ProjectsCancelled.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.EventsCompleted.name}
        subtitle="Display sites by number of completed events."
        selected={search.order === orderMap.EventsCompleted.param}
        onClick={() => onChange(orderMap.EventsCompleted.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.EventsActive.name}
        subtitle="Display sites by number of incomplete/active events."
        selected={search.order === orderMap.EventsActive.param}
        onClick={() => onChange(orderMap.EventsActive.param)} />
      
      <DropdownFilter.MenuItem
        icon={FolderIcon}
        title={orderMap.EventsCancelled.name}
        subtitle="Display sites by number of cancelled events."
        selected={search.order === orderMap.EventsCancelled.param}
        onClick={() => onChange(orderMap.EventsCancelled.param)} />
      
    </DropdownFilter>);

}